"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const FormActions = ({
  children,
  classes,
  align
}) => _react.default.createElement("div", {
  className: classes.formActions,
  style: {
    justifyContent: align === 'left' ? 'flex-start' : align === 'right' ? 'flex-end' : 'center'
  }
}, children);

FormActions.propTypes = {
  align: _propTypes.default.oneOf(['left', 'right'])
};

var _default = (0, _reactJss.default)(theme => ({
  formActions: {
    marginTop: theme.sizes.formActionsDistance,
    lineHeight: 'normal',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    margin: -10,
    '& > *': {
      margin: 10
    }
  }
}))(FormActions);

exports.default = _default;